<div class="copy-template-dialog-content">
  <div class="header">
    <div class="header__icon-shell">
      <svg-icon class="copy-icon" aria-label="Copy Icon" key="copy"></svg-icon>
    </div>
    <h2>{{ "copyTemplate.title" | transloco }}</h2>
    <button type="button" class="close-button" aria-label="Close Dialog" (click)="closeDialog()">
      <svg-icon key="times" aria-hidden="true"></svg-icon>
    </button>
  </div>

  <p-tabView class="underline-tabs copy-template-tabs" [(activeIndex)]="activeTabIndex">
    <p-tabPanel header="History">
      <ng-template pTemplate="header">
        <svg-icon class="tab-icon" key="clock" aria-hidden="true"></svg-icon>
        <span>{{ "copyTemplate.history" | transloco }}</span>
      </ng-template>

      <div class="tab-section">
        <span class="error-label" *ngIf="historyErrorMessage">{{ historyErrorMessage }}</span>

        <div class="history-block">
          <p class="empty-state" *ngIf="completedHistoryItems.length === 0">{{ "copyTemplate.noHistory" | transloco }}.</p>

          <p-accordion *ngIf="completedHistoryItems.length > 0" [multiple]="false" [(value)]="expandedHistoryItem" class="history-accordion">
            <p-accordion-panel
              *ngFor="let historyItem of completedHistoryItems; trackBy: trackByHistoryItem"
              [value]="getHistoryPanelValue(historyItem)"
            >
              <p-accordion-header>
                <div class="history-header">
                  <div class="history-header__left">
                    <div class="history-header__icon-shell">
                      <svg-icon key="file-alt" aria-hidden="true"></svg-icon>
                    </div>
                    <div class="history-header__copy">
                      <div class="history-header__title-row">
                        <span class="history-header__template">{{ historyItem.templatePath }}</span>
                        <span class="history-header__status status-{{ (historyItem.status || 'unknown').toLowerCase() }}">
                          {{ historyItem.statusLabel }}
                        </span>
                      </div>
                      <b><div class="history-header__label">{{ "copyTemplate.templatePath" | transloco }}</div></b>
                      <div class="history-header__value">{{ historyItem.templatePath }}</div>
                    </div>
                  </div>

                  <div class="history-header__meta-group">
                    <div class="history-header__meta">
                      <div class="history-header__meta-badge">
                        <svg-icon key="user" aria-hidden="true"></svg-icon>
                      </div>
                      <div>
                        <div class="history-header__meta-label">{{ "copyTemplate.processedBy" | transloco }}</div>
                        <div class="history-header__meta-value">{{ historyItem.processedByName || 'N/A' }}</div>
                      </div>
                    </div>
                    <div class="history-header__meta">
                      <div class="history-header__meta-badge">
                        <svg-icon key="user-tie" aria-hidden="true"></svg-icon>
                      </div>
                      <div>
                        <div class="history-header__meta-label">{{ "copyTemplate.position" | transloco }}</div>
                        <div class="history-header__meta-value">
                          {{ getDisplayValues(historyItem.positions, positionOptions) }}
                        </div>
                      </div>
                    </div>
                    <div class="history-header__meta">
                      <div class="history-header__meta-badge">
                        <svg-icon key="school" aria-hidden="true"></svg-icon>
                      </div>
                      <div>
                        <div class="history-header__meta-label">{{ "copyTemplate.grade" | transloco }}</div>
                        <div class="history-header__meta-value">
                          {{ getDisplayValues(historyItem.gradeLevels, gradeOptions) }}
                        </div>
                      </div>
                    </div>
                    <div class="history-header__meta">
                      <div class="history-header__meta-badge">
                        <svg-icon key="calendar-alt" aria-hidden="true"></svg-icon>
                      </div>
                      <div>
                        <div class="history-header__meta-label">{{ "copyTemplate.startDate" | transloco }}</div>
                        <div class="history-header__meta-value">{{ historyItem.startDate | date : 'medium' }}</div>
                      </div>
                    </div>
                  </div>

                  <ng-template #toggleicon let-active="active">
                    <svg-icon class="history-header__chevron" [key]="active ? 'chevron-up' : 'chevron-down'" aria-hidden="true"></svg-icon>
                  </ng-template>
                </div>
              </p-accordion-header>

              <p-accordion-content>
                <div class="history-summary-grid">
                  <div class="history-summary-item">
                    <div class="history-summary-item__badge">
                      <svg-icon key="calendar-alt" aria-hidden="true"></svg-icon>
                    </div>
                    <div class="history-summary-item__label">{{ "copyTemplate.endDate" | transloco }}</div>
                    <div class="history-summary-item__value">{{ historyItem.endDate ? (historyItem.endDate | date : 'medium') : 'N/A' }}</div>
                  </div>
                  <div class="history-summary-item">
                    <div class="history-summary-item__badge">
                      <svg-icon key="check" aria-hidden="true"></svg-icon>
                    </div>
                    <div class="history-summary-item__label">{{ "copyTemplate.success" | transloco }}</div>
                    <div class="history-summary-item__value">{{ historyItem.successCount }}</div>
                  </div>
                  <div class="history-summary-item">
                    <div class="history-summary-item__badge">
                      <svg-icon key="times" aria-hidden="true"></svg-icon>
                    </div>
                    <div class="history-summary-item__label">{{ "copyTemplate.failure" | transloco }}</div>
                    <div class="history-summary-item__value">{{ historyItem.failedCount }}</div>
                  </div>
                  <div class="history-summary-item">
                    <div class="history-summary-item__badge">
                      <svg-icon key="file-alt" aria-hidden="true"></svg-icon>
                    </div>
                    <div class="history-summary-item__label">{{ "copyTemplate.total" | transloco }}</div>
                    <div class="history-summary-item__value">{{ historyItem.total }}</div>
                  </div>
                </div>

                <div class="failure-section" *ngIf="historyItem.failureDetails.length > 0">
                  <h4>{{ "copyTemplate.failureReasons" | transloco }}</h4>
                  <p-table [value]="historyItem.failureDetails" class="failure-table" [scrollable]="true" scrollHeight="16rem">
                    <ng-template pTemplate="header">
                      <tr>
                        <th>{{ "copyTemplate.accountId" | transloco }}</th>
                        <th>{{ "copyTemplate.reason" | transloco }}</th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-failure>
                      <tr>
                        <td>{{ failure.accountName }}</td>
                        <td>{{ failure.reason }}</td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </p-accordion-content>
            </p-accordion-panel>
          </p-accordion>
        </div>
      </div>
    </p-tabPanel>

    <p-tabPanel header="Push Template">
      <ng-template pTemplate="header">
        <svg-icon class="tab-icon" key="cloud-upload" aria-hidden="true"></svg-icon>
        <span>{{ "copyTemplate.title" | transloco }}</span>
      </ng-template>

      <div class="tab-section">
        <span class="error-label" *ngIf="errorMessage">{{ errorMessage }}</span>

        <div class="dropdown-row">
          <div class="input-field">
            <label class="input-field__label" for="positionMultiSelect">{{ 'copyTemplate.position' | transloco }}</label>
            <aero-multiselect
              name="positions"
              id="positionMultiSelect"
              class="input copy-template-multiselect"
              placeholder="{{'copyTemplate.positionPlaceholder' | transloco }}"
              [options]="positionOptions"
              [(value)]="selectedPositions"
              [(ngModel)]="selectedPositions"
              (ngModelChange)="onPositionsChange($event)"
              optionLabel="name"
              optionValue="code"
              [dataKey]="'code'"
            >
            </aero-multiselect>
          </div>

          <div class="input-field">
            <label class="input-field__label" for="gradeMultiSelect">{{ 'copyTemplate.grade' | transloco }}</label>
            <aero-multiselect
              name="grades"
              id="gradeMultiSelect"
              class="input copy-template-multiselect"
              placeholder="{{ 'copyTemplate.gradePlaceholder' | transloco }}"
              [options]="gradeOptions"
              [(value)]="selectedGrades"
              [(ngModel)]="selectedGrades"
              (ngModelChange)="onGradesChange($event)"
              optionLabel="name"
              optionValue="code"
              [dataKey]="'code'"
            >
            </aero-multiselect>
          </div>
        </div>

        <div class="templates-section">
          <ng-container *ngFor="let input of inputs; let i = index">
            <div class="input-field">
              <label *ngIf="i === 0" class="input-field__label bulb-required" for="template">{{ 'copyTemplate.template' | transloco }}</label>
              <span class="text-box">
                <aero-input
                  [type]="input.type"
                  [id]="'template' + i"
                  [name]="'template' + i"
                  placeholder="{{ 'copyTemplate.templatePlaceholder' | transloco }}"
                  [(ngModel)]="input.value"
                >
                </aero-input>
                <svg-icon
                  *ngIf="i === inputs.length - 1"
                  class="plus-icon"
                  role="button"
                  aria-label="Add template"
                  (click)="addTemplateField()"
                  key="plus"
                ></svg-icon>
              </span>
            </div>
          </ng-container>
        </div>

        <div class="dialog-buttons">
          <aero-button [aeroStyle]="aeroStyleGrey" (click)="closeDialog()" labelCode="account_settings_cancel"></aero-button>
          <aero-button [disabled]="!isButtonEnabled()" (click)="onCopyTemplate()" label="{{'copyTemplate.pushButton' | transloco }}"></aero-button>
        </div>
      </div>
    </p-tabPanel>
  </p-tabView>
</div>
